//image sizes for tmdb
export const img_300 = "https://image.tmdb.org/t/p/w300";
export const img_500 = "https://image.tmdb.org/t/p/w500";

// contentModal and singleContent
export const unavailable =
  "https://www.movienewz.com/img/films/poster-holder.jpg";

// contentModal
export const unavailableLandscape =
  "https://user-images.githubusercontent.com/10515204/56117400-9a911800-5f85-11e9-878b-3f998609a6c8.jpg";

// For Carousel
export const noPicture =
  "https://upload.wikimedia.org/wikipedia/en/6/60/No_Picture.jpg";

export const movie_icon = "https://media.istockphoto.com/photos/video-camera-icon-cyan-blue-glossy-round-button-picture-id613346170?k=6&m=613346170&s=612x612&w=0&h=MZr2NIhtRd1QTZiXeZEYPdA5MOWS-73DkFxwWhY7VM8="

export const trending_icon = "https://th.bing.com/th/id/OIP.a_MxunCW3MzdBcdRWkntegHaHa?pid=ImgDet&w=600&h=600&rs=1"

export const Tv_series_icon = "https://th.bing.com/th/id/OIP.LuMlp8pwqRHEAUdHEsedtgAAAA?pid=ImgDet&w=340&h=340&rs=1"